import React from "react";
import { Link } from "react-router-dom";
import { Layout, Row, Col } from "antd";
import { PhoneOutlined, MailOutlined, HomeOutlined } from "@ant-design/icons";
import {
  ABOUTYOMAFLEET,
  BROWSE_CAR,
  CONTACT,
  FAQ,
  FARE_WEAR_AND_TEAR_POLICY,
  PRAVICY_AND_POLICY,
  REQUEST_A_CALLBACK,
  SITEMAP,
  SOLUTION_FOR_BUSINESS,
  TERM_AND_CONDITION,
} from "../../route/AppRouter";
const { Footer } = Layout;

const AppFooter = () => {
  return (
    <section id="appFooter">
      <Footer className="app-footer">
        <Row justify="center">
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <div className="menu-block-container">
              <h3 className="menu-header">{"GET IN TOUCH WITH US"}</h3>
              <p className="menu-address">
                <HomeOutlined className="menu-address-icon" />
                <span>The Campus</span>, 1 Rain Tree Drive, Pun Hlaing Golf
                Estate, Hlaing Thayar Township, Yangon 11401, Myanmar.
              </p>
              <br />
              <p className="menu-address">
                <PhoneOutlined className="menu-address-icon" />
                09 YOMAFLEET <br />
                <a href="tel:+959966235338">(09 966235338)</a>{" "}
              </p>
              <p className="menu-address">
                <MailOutlined className="menu-address-icon" />
                aung@yomafleet.com
              </p>
            </div>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <div className="menu-block-container">
              <h3 className="menu-header">{"EASY LEASE"}</h3>
              <Link to={BROWSE_CAR} className="footerLinkText">
                {"Find A Car"}
              </Link>
              <Link to={BROWSE_CAR} className="footerLinkText">
                {"Personal"}
              </Link>
              <Link to={SOLUTION_FOR_BUSINESS} className="footerLinkText">
                {"Business"}
              </Link>
              <Link to={ABOUTYOMAFLEET} className="footerLinkText">
                {"How Easy Lease Works"}
              </Link>
            </div>
            {/* <MenuBlock data={vehicles} /> */}
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <div className="menu-block-container">
              <h3 className="menu-header">{"POLICY"}</h3>
              <Link to={TERM_AND_CONDITION} className="footerLinkText">
                {"Terms & Conditions"}
              </Link>
              <Link to={FARE_WEAR_AND_TEAR_POLICY} className="footerLinkText">
                {"Fair Wear & Tear Policy"}
              </Link>
              <Link to={PRAVICY_AND_POLICY} className="footerLinkText">
                {"Privacy Policy"}
              </Link>
              <Link to={FAQ} className="footerLinkText">
                {"FAQ"}
              </Link>
            </div>
            {/* <MenuBlock data={support} /> */}
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 12 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
            xxl={{ span: 6 }}
          >
            <div className="menu-block-container">
              <h3 className="menu-header">{"Support"}</h3>
              <Link to={CONTACT} className="footerLinkText">
                {"Contact"}
              </Link>
              <Link to={REQUEST_A_CALLBACK} className="footerLinkText">
                {"Feedback"}
              </Link>
              <Link to={SITEMAP} className="footerLinkText">
                {"Sitemap"}
              </Link>
            </div>
          </Col>
        </Row>

        <Row justify="center" className="footer-link-container">
          <a href="http://yomafleet.com/">
            YOMA FLEET LTD, Part of the Yoma Group. &copy;{" "}
            {new Date().getFullYear()}{" "}
          </a>
        </Row>
      </Footer>
    </section>
  );
};

export default AppFooter;
